import { module } from 'modujs';
import LocomotiveScroll from 'locomotive-scroll';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        gsap.delayedCall(0.7, () => {
            this.scroll = new LocomotiveScroll({
                el: this.el,
                smooth: true,
                getDirection: true,
                getSpeed: true
            });

            if(!html.classList.contains('has-scroll-smooth')) {
                this.loop = () => {
                    if(html.scrollTop > 50) {
                        html.classList.add('has-scrolled');
                    } else {
                        html.classList.remove('has-scrolled');
                    }
                    this.loopRAF = requestAnimationFrame(this.loop)
                }
                this.loop()
            }

            window.scroll = this.scroll;

            this.scroll.on('call', (func, way, obj, id) => {
                // Using modularJS
                this.call(func[0], { way, obj }, func[1], func[2]);
            });

            this.scroll.on('scroll', (args) => {

                html.setAttribute('data-direction', args.direction)

                if(!this.loop) {
                    if (args.scroll.y > 50) {
                        html.classList.add('has-scrolled');
                    } else {
                        html.classList.remove('has-scrolled');
                    }
                }

                if (args.currentElements['projects-dolly-container']) {
                    this.call('setProgress', { progress: args.currentElements['projects-dolly-container'].progress, speed: args.speed }, 'ProjectsDolly')
                }

                // Get all current elements : args.currentElements
                if (typeof args.currentElements['hero'] === 'object') {
                    let progress = args.currentElements['hero'];
                    this.call('onScroll', [progress, args], 'Hero');
                }
            })

            gsap.delayedCall(1, () => {
                this.scroll.update();
            })
        });
    }

    toggleLazy(args) {
        let src = this.getData('lazy', args.obj.el)
        if (src.length) {
            if (args.obj.el.tagName == "IMG") {
                args.obj.el.src = src
            } else {
                args.obj.el.style.backgroundImage = `url(${src})`
            }
            this.setData('lazy', '', args.obj.el)
        }
    }

    update() {
        if(this.scroll && this.scroll.update) this.scroll.update();
    }

    scrollTo(param) {
        this.scroll.scrollTo(param.target, param.options);
    }

    destroy() {
        this.scroll.destroy();

        html.classList.remove('has-scrolled');
        cancelAnimationFrame(this.loopRAF)
    }
}
